import Permissions from "../../models/Permissions";
// import Fretes from './Index.vue'

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Subcontratações de Frete",
  icon: "fa fa-archive",
  group: "Contabil",
  permissions,
};

export default [
  {
    path: "/subcontracoesFrete",
    name: "Subcontratações de Frete",
    component: () => import("./Index.vue"),
    meta,
  },
];
